import clsx from 'clsx';
import * as React from 'react';
import { StoryblokComponent, storyblokEditable } from 'gatsby-source-storyblok';

export default function RichTextSection({ blok }) {
  return (
    <div
      {...storyblokEditable(blok)}
      className={clsx('blok-rich-text-section px-4 lg:px-16 ')}
    >
      {blok.blocks.map((block) => (
        <StoryblokComponent blok={block} key={block._uid} />
      ))}
    </div>
  );
}
 